import React from 'react';
import styles from './styles.scss';

function AvatarGroup(_ref) {
  var className = _ref.className,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("ol", {
    className: "".concat(styles.list, " ").concat(className)
  }, React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement("li", {
      className: styles.listItem,
      style: {
        zIndex: children.length - index
      }
    }, /*#__PURE__*/React.cloneElement(child, {
      className: "".concat(child.props.className, " ").concat(styles.avatar)
    }));
  }));
}

AvatarGroup.defaultProps = {
  className: ''
};
export default AvatarGroup;